export default {
	"roads": {
		"mobile": "Phone number",
		"executionHandle": "View implementation",
		"deliveryExecution": "Delivery execution",
		"billPayable": "bills payable",
		"routerNoDataRange": "Please enter the dispatch number or select the creation time range",
		"importDataCorrection": "Import Data Correction",
		"exportDataCorrection": "Export Data Correction",
		"downloadTransportManifest": "Download Transport Manifest",
		"backToDocPOD": "Back To Documentation & POD",
	},
	"roadsMultiple": {
		"waybillDetails": "Waybill details",
		"actualGoodsQty": "Quantity of goods actually picked up",
		"finishTransportQty": "Number of completed waybills",
		"actualTonKm": "Actual ton-kilometers",
		"actualFullLoadRatio": "Actual full load rate",
		"stayPointInformation": "stop point information",
		"roadsmultiple": "mileage",
		"latestReceiverStation": "nearest delivery point",
		"transitTime": "Transportation time",
		"senderAddressTips": "Allow input address selection"
	},
	"roadsSingle": {
		"actualTime": "actual time"
	},
	"roadsCheckStatus": {
		"save": "Save",
		"new": "New",
		"confirmed": "Confirmed",
		"recheck": "Recheck"
	},
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/roads/roads.js